import { Component, HostBinding, inject } from '@angular/core';
import { ContextService } from '@bcef/ia-shared';
import { clsx } from 'clsx';

@Component({
  selector: 'ia-report-technical-problem-base-layout',
  template: ``,
})
export class BaseLayoutComponent {
  protected readonly context = inject(ContextService);

  @HostBinding('class')
  public classAttributes = clsx([
    'hb-group:tw-font-hello-type-next',
    'nhb:tw-text-hb-base',
    'nhb:tw-leading-[1.35]',
    'nhb:tw-text-midnight-green',
    'tw-flex',
    'tw-flex-col',
    'mb-group:tw-text-eerie-black',
    'nhb:sm:tw-px-5',
    'hb-group:tw-pb-5',
    'hbpro:tw-px-5',
    'hbpro:sm:tw-mt-px',
    'hbpro:sm:tw-mx-auto',
    'hbpro:sm:tw-w-[990px]',
    'hb-group:tw-bg-white',
    this.context.isDesktop && 'hbpro:max-sm:tw-pt-15',
  ]);

  public headerClassAttributes = clsx([
    'part:[&_.inner-frame]:tw-bg-none',
    'part:[&_.inner-frame]:tw-from-deep-sea',
    'part:[&_.inner-frame]:tw-to-deep-sea',
    'part:[&_.ia-stepper-active-step]:tw-bg-fun-green',
    'mb-group:[&_.ia-stepper-mb-container]:tw-font-sans',
    'nhb:[&_.header-title]:tw-mb-14',
    'nhb:[&_.header-title]:tw-text-[32px]',
    'nhb:[&_.header-title]:tw-font-medium',
    'nhb:[&_.header-title]:tw-leading-tight',
    'hb-group:[&_.inner-frame]:tw-m-0',
    'nhb:md:[&_.ia-stepper-hb-container]:tw-flex-row',
    'nhb:md:[&_.ia-stepper-hb-container]:tw-items-center',
    'nhb:[&_.ia-stepper-step-status]:tw-text-dim-gray-2',
    'nhb:[&_.ia-stepper-steps]:tw-border-dim-gray-2',
    'nhb:[&_.ia-stepper-steps.ia-stepper-current-step]:tw-text-biscay-bay',
    'hbpro:[&_.header-title]:tw-font-hello-type-next',
    'hbpro:[&_.header-title]:tw-text-[32px]',
    'hbpro:[&_.header-title]:tw-text-[#037eb0]',
    'hbpro:[&_.ia-stepper-hb-container]:tw-font-hello-type-next',
    'hbpro:[&_.ia-stepper-hb-container]:tw-mt-6',
    'hbpro:tw-mb-6',
  ]);
}
